import { Schemas } from '../openapi'

export default (wish: Schemas['Wish'] | undefined) => {
  if (!wish) return null
  const imagesSet = !!wish?.photos?.[0]?.thumbnails?.length
    ? wish.photos[0]?.thumbnails
    : wish.photos
  return imagesSet?.[0]?.url
}
